import React from "react";
import * as FiIcons from "react-icons/fi";
import SafeIcon from "../../../common/SafeIcon";

const { FiBriefcase, FiExternalLink, FiMapPin } = FiIcons;

function safeWebsite(value) {
  if (!value) return "";
  try {
    const url = new URL(
      value.startsWith("http") ? value : `https://${value}`
    );
    return ["http:", "https:"].includes(url.protocol) ? url.href : "";
  } catch {
    return "";
  }
}

export default function ClientAccountingFirmCard({
  firm,
  clientProfile,
}) {
  if (!firm) {
    return (
      <section className="rounded-2xl border border-dashed border-slate-300 bg-white p-6">
        <h2 className="text-base font-bold text-slate-900">
          No Accounting Firm Connected
        </h2>
        <p className="mt-2 text-sm leading-6 text-slate-600">
          Your business is not currently linked to an accounting firm.
        </p>
      </section>
    );
  }

  const website = safeWebsite(firm.website);

  return (
    <section className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
      <div className="flex items-start gap-4">
        <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-violet-50 text-violet-700">
          <SafeIcon icon={FiBriefcase} className="text-xl" />
        </span>
        <div className="min-w-0 flex-1">
          <p className="text-xs font-semibold uppercase tracking-wider text-violet-700">
            Your Accounting Firm
          </p>
          <h2 className="mt-1 break-words text-lg font-bold text-slate-900">
            {firm.name}
          </h2>
        </div>
        <span className="rounded-full bg-emerald-50 px-3 py-1 text-xs font-bold text-emerald-700">
          Connected
        </span>
      </div>

      <dl className="mt-6 grid gap-4 border-t border-slate-100 pt-5 sm:grid-cols-2">
        <div>
          <dt className="text-xs text-slate-500">Firm type</dt>
          <dd className="mt-1 text-sm font-semibold capitalize text-slate-800">
            {firm.type === "accounting_firm"
              ? "Accounting firm"
              : "Accountant practice"}
          </dd>
        </div>
        <div>
          <dt className="text-xs text-slate-500">Relationship</dt>
          <dd className="mt-1 text-sm font-semibold text-slate-800">
            Active firm relationship
          </dd>
        </div>
        {firm.country && (
          <div>
            <dt className="text-xs text-slate-500">Country</dt>
            <dd className="mt-1 flex items-center gap-1.5 text-sm text-slate-800">
              <SafeIcon icon={FiMapPin} className="text-slate-400" />
              {firm.country}
            </dd>
          </div>
        )}
        {clientProfile?.bookkeeping_manager && (
          <div>
            <dt className="text-xs text-slate-500">Bookkeeping manager</dt>
            <dd className="mt-1 text-sm text-slate-800">
              {clientProfile.bookkeeping_manager}
            </dd>
          </div>
        )}
      </dl>

      {website && (
        <a
          href={website}
          target="_blank"
          rel="noreferrer"
          className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-violet-700 hover:text-violet-900"
        >
          Visit firm website
          <SafeIcon icon={FiExternalLink} />
        </a>
      )}
    </section>
  );
}